import React from 'react'

const Step4 = () => {
  return (
    <div className='step4'>
      <div className="s4-h">
        <div className='s4-h-c'>
          <h2>AMA with COO of The Sandbox <br /> Sebastien Borget</h2>
        </div>
        <div className='s4-h-c'>
          <h2>Collaboration <br /> Partners</h2>
        </div>
      </div>
      <div className="s4-img">
        <div className='s4-i-c SB'>
          <img src="images/steps/SebastienBorget.png" alt="" />
        </div>
        <div className='s4-i-c SB-rt'>
          <img src="images/steps/Group 12.png" alt="" />
        </div>
      </div>
    </div>
  )
}

export default Step4